import React from "react";
import * as S from "./GoSafeSafetyUpdates.styles";
import Icon from "../../../../core-components/IconsSelector";
import useCarousel from "../../../../../shared/containers/useCarousel/useCarousel";

interface IGosafeSafety {
  subtitle: Array<{}>;
  title: string;
  node: Array<IList>,
  onStoryClick: Function
}

interface IList {
  expire_at: string;
  published_at: string;
  story: Array<{}>,
  story_label: string;
  user: IUser
}
interface IUser {
  name: string;
  thumb: string;
}

const GoSafeSafetyUpdatesUI: React.FC<IGosafeSafety> = ({ title = '', subtitle = [], node = [], onStoryClick }) => {
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(node, 9);
  return (
    <S.SafetyWrapper>
      <S.SafetyHeader>
        <S.SafetyTag>
        <Icon
          name="GosafeIcon"
          styleProps={{ width: "5.6rem"}}
        />
        </S.SafetyTag>
        <div>
          {title ? <h4>{title}</h4> : null}
          {subtitle?.length ?
          <>
            {
              subtitle.map((data) => (
                <>
                  <Icon
                    name="SafetyCheck"
                  />
                  <S.SubTitle>
                    {data}</S.SubTitle>
                </>
              ))
              }
          </>
          : null}
        </div>
      </S.SafetyHeader>
      {dataList?.length ? (
        <S.SafetyList>
          {dataList.map(({ user, story, story_label }, index) => (
            <S.SafetyListItem key={`safety${index}`}  bgImage={story[0]?.thumb} onClick={() => onStoryClick({ user, story, story_label })}>
              <div className="itemTop">
                <img src={user?.thumb} className="driverIcon" alt="profile picture"></img>
                <span className="driverName">{user?.name}</span>
              </div>
              {story_label ? <div className="foot">{story_label}</div> : null}
            </S.SafetyListItem>
          ))}
        </S.SafetyList>
      ) : null}
        {isRightCursorActive ? (
        <S.SliderArrow
          className="right"
          onClick={() => {
            increment();
          }}
        >
          <Icon name="ArrowRightIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
      {isLeftCursorActive ? (
        <S.SliderArrow
          className="left"
          onClick={() => {
            decrement();
          }}
        >
          <Icon name="ArrowLeftIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
    </S.SafetyWrapper>
  );
};

export default GoSafeSafetyUpdatesUI;
